export default {"src":"/_next/static/media/three-ellipse-white-mobile.617773eb.svg","height":27,"width":19};